import { useState } from "react";
import { useTranslation } from "react-i18next";
import SearchAuditLogsReportCard from "../../../components/card/SearchAuditLogsReportCard";
import AuditLogsReportTable from "../../../components/table/AuditLogsReportTable";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import { ExportAuditLogsReportForExcelPDFBody } from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";

const AuditLogsReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportAuditLogsReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allLogs, setAllLogs] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("auditLogsReport")}
        </h1>
      </BackButtonWrapper>

      <SearchAuditLogsReportCard
        setAllLogs={setAllLogs}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <AuditLogsReportTable
        allLogs={allLogs}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default AuditLogsReport;
